import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../utils/axiosConfig';
import LoyaltyCard from './LoyaltyCard';
import { setAuthToken } from '../utils/auth';

function ProgramLoyaltyCard() {
  const [program, setProgram] = useState(null);
  const { subUrl, programId } = useParams();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuthToken(token);
    }
    fetchProgramDetails();
  }, [subUrl, programId]);

  const fetchProgramDetails = async () => {
    try {
      const response = await axios.get(`/api/customers/programs/${programId}`);
      setProgram(response.data);
    } catch (error) {
      console.error('Error fetching program details:', error);
    }
  };

  if (!program) return <div>Loading...</div>;

  return (
    <div className="program_loyalty_specific_container">
      <h1 className="program_loyalty_specific_vendor_title">{program.vendor_name}</h1>
      <h2 className="program_loyalty_specific_subtitle">{program.name} Loyalty Card</h2>
      <LoyaltyCard program={program} />
      
      {/* Inline styles for only the titles and container */}
      <style>
        {`
          .program_loyalty_specific_container {
            max-width: 600px;
            margin: 0 auto;
            padding: 15px;
          }
          
          .program_loyalty_specific_vendor_title {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-size: 2rem;
            font-weight: 700;
            color: #2c3e50;
            text-align: center;
            margin-bottom: 8px;
          }
          
          .program_loyalty_specific_subtitle {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-size: 1.5rem;
            font-weight: 600;
            color: #3498db;
            text-align: center;
            margin-top: 0;
            margin-bottom: 20px;
          }
        `}
      </style>
    </div>
  );
}

export default ProgramLoyaltyCard;